import { useNavigate } from "react-router-dom";
import Page from "src/layouts/Page";
import KeyShoutForm, {
	KeyShoutFormValues
} from "../../components/KeyShoutForm/KeyShoutForm";
import useCreateKeyShout from "../../hooks/useCreateKeyShout";
import { adaptCreateKeyShoutPayload } from "../../adapters/adaptKeyShoutPayload";
import { formValuesToKeyShout } from "../../adapters/formValuesToKeyShout";

const EMPTY_DEFAULTS: KeyShoutFormValues = {
	heading: "",
	content: "",
	buttonLink: "",
	webview: true,
	feedId: null,
	selectedFeed: null,
	image: null,
	audienceGroupIds: []
};

const CreateKeyShout = () => {
	const navigate = useNavigate();
	const { mutate: createKeyShout, isLoading } = useCreateKeyShout();

	const handleSubmit = (data: KeyShoutFormValues) => {
		const payload = adaptCreateKeyShoutPayload(
			formValuesToKeyShout(data),
			data.image
		);

		createKeyShout(payload, {
			onSuccess: () => navigate("/app/homepage/key-shouts")
		});
	};

	return (
		<Page>
			<KeyShoutForm
				defaultValues={EMPTY_DEFAULTS}
				onSubmit={handleSubmit}
				isSubmitting={isLoading}
			/>
		</Page>
	);
};

export default CreateKeyShout;
